import { useState } from "react";
import axios from "axios";

const ReadPdfReceiptCourt = () => {
  const [data, setData] = useState(null);
  const [loadingReadPdfReceiptLawsuit, setLoadingReadPdfReceiptLawsuit] =
    useState(false);
  const [error, setError] = useState(null);

  const uploadToApi = async (file) => {
    if (!file) {
      setError("กรุณาเลือกไฟล์ PDF ก่อนครับ");
      return null;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("doc_type", "lawsuit_receipt");

    setLoadingReadPdfReceiptLawsuit(true);
    setError(null);

    try {
      const response = await axios.post(
        "https://p01--lawyer-parser-api--pk5yxk5dqpy4.code.run/api/v1/extract",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": "Nickie_Secret_2026",
          },
        },
      );

      const result = response.data.data;
      setData(result);
      return result;
    } catch (err) {
      const errMsg =
        err.response?.data?.detail ||
        err.message ||
        "เกิดข้อผิดพลาดในการเชื่อมต่อ API";
      setError(errMsg);
      console.error("Upload Error:", errMsg);
      return null;
    } finally {
      setLoadingReadPdfReceiptLawsuit(false);
    }
  };

  const resetData = () => {
    setData(null);
    setError(null);
  };

  return { uploadToApi, data, loadingReadPdfReceiptLawsuit, error, resetData };
};

export default ReadPdfReceiptCourt;
